import { DeviceStatus } from 'types/device.enum';
import { NON_PROBLEMATIC_SAMPLE_STATUS_CODES, SampleStatusCode } from 'types/sample.enum';

/**
 * Non-online device status wins; when the device is
 * online, a problematic sample status (if exists) is shown.
 */
export function prioritiseStatus(
  deviceStatus: DeviceStatus,
  latestSampleStatus: SampleStatusCode
): DeviceStatus | SampleStatusCode {
  if (deviceStatus !== DeviceStatus.ONLINE) {
    return deviceStatus;
  }
  if (NON_PROBLEMATIC_SAMPLE_STATUS_CODES.includes(latestSampleStatus) === false) {
    return latestSampleStatus;
  }
  return DeviceStatus.ONLINE;
}
